import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { planningQuestions, workflow } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Workflow() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-304" data-mp="2an2ybu6bcijm">
      <div className="mx-auto max-w-3xl" data-id="element-305" data-mp="2al9pq9c53o8z">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-306" data-mp="25pb6t19kyyfy">
          Non è solo un altro ebook sugli allineatori
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-307" data-mp="1vqbxdggzqyrw">
          Un unico flusso di lavoro, dalla diagnosi alla finalizzazione
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-308" data-mp="1mpnjqmvif0fj">
          Il software può mostrarti un piano di trattamento, ma non può sostituire il tuo giudizio clinico. Il Sistema
          ti aiuta a costruire un processo di revisione ripetibile attorno alle aree cliniche più importanti.
        </p>

        <ol className="relative mt-9 space-y-3 pl-1" data-id="element-309" data-mp="2wlik99rtju77">
          {workflow.map(item => <li key={item.step} className="flex items-start gap-4 rounded-2xl border border-navy/10 bg-white p-4" data-id="element-310" data-mp="31mptzediv3gi">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy font-display text-base font-bold text-white" data-id="element-311" data-mp="2nn6vzeefd8hx">
                {item.step}
              </span>
              <div className="min-w-0" data-id="element-312" data-mp="3gbuckwo8b9p5">
                <h3 className="font-display text-[17px] font-bold leading-snug text-navy" data-id="element-313" data-mp="3gcx67ccxrq8r">{item.title}</h3>
                <p className="mt-1 text-[14px] leading-relaxed text-navy/65" data-id="element-314" data-mp="36krbvvz7owqe">{item.body}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-10 rounded-3xl bg-navy p-5 sm:p-7" data-id="element-315" data-mp="3bijd5glqxv79">
          <h3 className="font-display text-xl font-bold leading-snug text-white sm:text-2xl" data-id="element-316" data-mp="33hhpindyz28">
            Immagina di aprire il tuo prossimo caso con un piano
          </h3>
          <p className="mt-3 text-[14px] leading-relaxed text-white/60" data-id="element-317" data-mp="7wkctv7tagkj">
            Invece di chiederti <em data-id="element-318" data-mp="hodj4tl3c0c8">“Questo ClinCheck sembra corretto?”</em>, affronti il caso con una sequenza
            strutturata di domande:
          </p>
          <ul className="mt-4 space-y-2" data-id="element-319" data-mp="7rqzu98exhcb">
            {planningQuestions.map(question => <li key={question} className="flex items-start gap-2.5 rounded-xl bg-white/[0.06] px-3.5 py-3 text-[14px] leading-snug text-white/85" data-id="element-320" data-mp="2u8q4gmkmy39">
                <HelpCircleIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-321" data-mp="3q69p9rcnx2xh" />
                <span data-id="element-322" data-mp="3l6ncfj0qxop7">{question}</span>
              </li>)}
          </ul>
        </div>

        <CtaBlock className="mt-9" label="Voglio il mio processo ripetibile" data-id="element-323" data-mp="3g94zzinisrcg" />
      </div>
    </section>;
}